import { base64url } from 'multiformats/bases/base64';
export function toBase64url(b) {
    return base64url.encode(b).slice(1);
}
export function fromBase64url(s) {
    return base64url.decode(`u${s}`);
}
//# sourceMappingURL=utils.js.map